import { createResource } from '@atlassian/react-resource-router';
import type { AppLink } from './types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-knowledge-base-app-links", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-app-links" */ './get-data'
	);

export const servicedeskKnowledgeBaseAppLinksResource = createResource<AppLink[]>({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_APP_LINKS',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader,
	maxAge: Infinity,
});
